import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initializeAdSenseAds } from './utility/googleAds';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            initializeAdSenseAds();
        }, 400);

        return () => clearTimeout(timeout);
    }, [pathname]);

    return null;
};

export default ScrollToTop;